import { render, staticRenderFns } from "./MyRequestAddon.vue?vue&type=template&id=7f129b70"
import script from "./MyRequestAddon.vue?vue&type=script&lang=js"
export * from "./MyRequestAddon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports